import React from 'react'
import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../../contexts/user.context';
import RoundtableRoute from '../roundtable-route/roundtable-route';

const PublicRoute = ({children}) => {
    const {currentUser} = useContext(UserContext);
    if (currentUser){
        return <Navigate to="/dashboard " />
    }
    return <RoundtableRoute>{children}</RoundtableRoute>;
}

export default PublicRoute;